import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../api/baseurl";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Spinner.css";
import "./hm-theme.css";

const TestCsvFile = ({ isOpen, onRequestClose }) => {
  const [tests, setTests] = useState({
    categoryid: "",
    file: null,
  });

  const [loading, setLoading] = useState(false);
  const [csvFile, setCsvFile] = useState(null);
  const [categories, setCategories] = useState([]);

  const url = "/api/labtest/upload";
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      const token = JSON.parse(localStorage.getItem("data")).token;
      const catUrl = `/api/testcategory/status=true`;

      try {
        const response = await axios.get(catUrl, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCategories(response.data);
      } catch (error) {
        handleError(error);
      }
    };

    fetchCategories();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!tests.categoryid) {
      toast.error("Please select a category.");
      return;
    }
    if (!csvFile) {
      toast.error("Please choose a CSV file to upload.");
      return;
    }
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;
    const formData = new FormData();
    formData.append("file", csvFile);
    formData.append("categoryid", tests.categoryid);

    try {
      await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      toast.success("CSV file uploaded successfully");
      onRequestClose();
      setTests({ categoryid: "", file: null });
      setCsvFile(null);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const rhandle = (e) => {
    const { id, value } = e.target;
    setTests((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleCsvFileChange = (e) => {
    const file = e.target.files[0];
    setCsvFile(file);
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">cloud_upload</i>
          Upload Tests CSV
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          <div className="row g-3 mb-3">
            <div className="col-12">
              <label htmlFor="categoryid" className="form-label small fw-semibold">
                Category <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                id="categoryid"
                value={tests.categoryid}
                onChange={rhandle}
                required
              >
                <option value="">Select Category</option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.categoryname}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-12">
              <label htmlFor="file" className="form-label small fw-semibold">
                Upload Document <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                id="file"
                type="file"
                accept=".csv"
                onChange={handleCsvFileChange}
                required
              />
              {csvFile && (
                <div className="mt-2">
                  <span className="hm-badge hm-badge-info d-inline-flex align-items-center gap-1">
                    <i className="material-icons" style={{ fontSize: "0.85rem" }}>
                      description
                    </i>
                    {csvFile.name} ({(csvFile.size / 1024).toFixed(1)} KB)
                  </span>
                </div>
              )}
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-end gap-2 pt-3 border-top mt-3">
            <button
              type="button"
              className="btn btn-outline-secondary rounded-pill px-4"
              onClick={onRequestClose}
            >
              Close
            </button>
            <button
              type="submit"
              className="btn-hm-primary px-4"
              disabled={loading || !csvFile || !tests.categoryid}
            >
              {loading ? "Uploading..." : "Save"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default TestCsvFile;

